<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12 ml-auto mr-auto">
                <div class="card">
                    <div class="card-header card-header-success card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">account_circle</i>
                        </div>
                        <h4 class="card-title">Reporte de Prospección</h4>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="busquedaForm">
                        <div class="row">
                            <div class="col-sm-4">
                                <mat-form-field>
                                    <mat-label>Buscar por rango de fechas</mat-label>
                                    <mat-date-range-input [rangePicker]="picker">
                                      <input aria-label="Fecha de inicio" formControlName="fechaInicial" matStartDate placeholder="Fecha de inicio" (dateChange)="onStartDateChange($event)">
                                      <input aria-label="Fecha de fin" formControlName="fechaFinal" matEndDate placeholder="Fecha de fin" (dateChange)="onEndDateChange($event)">
                                    </mat-date-range-input>
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker></mat-date-range-picker>
                                  </mat-form-field>                                                   
                            </div>
                            <div class="col-sm-1">
                                <button mat-raised-button type="button" class="btn btn-info btn-round btn-fab" (click)="filtroBusqueda()">
                                    <i class="material-icons">search</i>
                                </button>
                            </div>
                            <div class="col-sm-1">
                                <button mat-raised-button type="button" class="btn btn-info btn-round btn-fab" (click)="limpiarFiltros()">
                                    <i class="material-icons">delete_sweep</i>
                                </button>                                 
                            </div>
                        </div>
                    </form>
                        <div class="table-responsive">
                            <table
                                id="reporte-prospeccion"
                                class="table table-shopping table-striped table-no-bordered table-hover"
                                cellspacing="0"
                                width="100%"
                                style="width: 100%"
                            >
                                <thead>
                                    <tr>
                                        <th class="text-center">Descripción</th>
                                        <th class="text-center">Fecha de inicio</th>
                                        <th class="text-center">Actividad Seguimiento</th>
                                        <th class="text-center">Compromiso Seguimiento</th>
                                        <th class="text-center">Estatus</th>
                                        <th class="text-center">Cliente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="
                                            let prospecto of listaProspectos
                                                | paginate
                                                    : {
                                                        id: 'reporteProspeccion',
                                                        itemsPerPage: pageSize,
                                                        currentPage: currentPage,
                                                        totalItems: totalRegistros
                                                    }
                                        "
                                    >
                                        <td class="text-center">{{prospecto.descripcion}}</td>
                                        <td class="text-center">{{prospecto.fechaInicio | date: 'dd/MM/yyyy'}}</td>
                                        <td class="text-center">{{prospecto.actividadSeguimiento}}</td>
                                        <td class="text-center">{{prospecto.compromisoSeguimiento}}</td>
                                        <td class="text-center">{{prospecto.estatus}}</td>
                                        <td class="text-center">{{prospecto.razonsocial}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="pagination-wrapper mt-3" *ngIf="showPagination">
                            <pagination-controls
                                [id]="'reporteProspeccion'"
                                responsive="true"
                                class="my-pagination"
                                [directionLinks]="true"
                                [autoHide]="false"
                                [previousLabel]="labels.previousLabel"
                                [nextLabel]="labels.nextLabel"
                                [maxSize]="5"
                                (pageChange)="consultaPagina($event)"
                            ></pagination-controls>
                        </div>

                        <div class="pagination-info mb-2" *ngIf="showPagination">
                            <small class="text-muted">P&aacute;gina {{ currentPage }} de {{ totalPages || 1 }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
